module.exports = __webpack_public_path__ + "static/media/home8.45ccba2e.jpg";